import { utilBalancing } from "../utils/utilBalancing";
export var selectBalancingMarketImprovements = function () {
    return utilBalancing.getBalancing().MarketImprovements;
};
export var balancingMarketImprovementsMemoizedFunctions = [selectBalancingMarketImprovements];



//////////////////
// WEBPACK FOOTER
// ./src/balancingSelectors/selectBalancingMarketImprovements.ts
// module id = 677
// module chunks = 3